import { getDoc, doc } from "firebase/firestore";
import db from "./firebase-config";
import foto from "../assets/sin_foto.png";

export const obtenerDatos = async () => {
  //console.log("get store")
  //console.log(store.getState().modalidad.modalidadSeleccionada.presku)

  //obtengo el arreglo de fotos
  const docRefFotos = doc(db, "publico", "fotos_medicamentos_new");
  const docSnapFotos = await getDoc(docRefFotos);
  let arrFotosFirebase = docSnapFotos.data().images_med;
  //console.log("arrFotosFirebase")
  // console.log(arrFotosFirebase[0])

  // const docRef = doc(db, "publico", "presku1")   obteniendo stock desde bodega central, se modifica temporalmente
  const docRef = doc(db, "publico_test", "new_presku02");
  // console.log("obtengo desde "+store.getState().modalidad.modalidadSeleccionada.presku)
  const docSnap = await getDoc(docRef);
  let arrPrevio = docSnap.data().sku;

  for (const element of arrPrevio) {
    //console.log(element.kinf)
    let nuevaUrl =
      "https://ligafarmacia.cl/product/" +
      element.kinf2 +
      "-" +
      element.nombre_medicamento
        .replace(/\s+/g, "-")
        .replace(/[.,%/]/g, "")
        .toLowerCase();
    element.woo_url = nuevaUrl;
    try {
      let obj = arrFotosFirebase.find(
        (e) =>
          e.kinf === element.kinf &&
          e.kinf2?.substr(-4) === element.kinf2?.substr(-4),
      );
      // console.log("ese obj")
      // console.log(obj)

      if (obj && Array.isArray(obj.image) && obj.image.length > 0) {
        const mapped = obj.image.map((img) => {
          if (typeof img !== "string") return null;
          if (img.includes("firebase")) {
            return { url: img };
          } else {
            return {
              url: `https://ligafarmacia.cl/${img.replace(".jpg", ".webp")}`,
            };
          }
        }).filter(Boolean);

        element.image = mapped.length > 0 ? mapped : [{ url: foto }];
      } else {
        element.image = [{ url: foto }];
      }
    } catch (error) {
      console.error("Error al asignar la imagen:", error);
      element.image = [{ url: foto }]; // Asignar imagen por defecto en caso de error
    }
  }

  //console.log("carga completa")

  arrPrevio.sort((a, b) =>
    a.nombre_medicamento.toLowerCase() > b.nombre_medicamento.toLowerCase()
      ? 1
      : -1,
  );

  let arrFinal = arrPrevio.filter(
    (product) =>
      product.image[0] !== "../assets/sin_foto.png" ||
      product.image.length !== 0,
  );
  // console.log(arrFinal);
  return arrFinal;
};
export const datosSedes = async () => {
  const docRef = doc(db, "publico", "datos_sedes");
  const docSnap = await getDoc(docRef);
  let arrSedes = docSnap.data().direccion_farmacias;
  return arrSedes;
};
export const datosMedicamentosImportados = async () => {
  const docRef = doc(db, "publico_test", "importados");
  const docSnap = await getDoc(docRef);
  let arrMedicamentos = docSnap.data().sku;
  arrMedicamentos.sort((a, b) =>
    a.nombre_medicamento.toLowerCase() > b.nombre_medicamento.toLowerCase()
      ? 1
      : -1,
  );
  return arrMedicamentos;
};
